import { Badge, Body1, Card, tokens } from '@fluentui/react-components';
import { ClockRegular } from '@fluentui/react-icons';
import { PageHeader } from '../components/PageHeader';

interface ComingSoonPageProps {
  title: string;
  description?: string;
}

export function ComingSoonPage({ title, description }: ComingSoonPageProps) {
  return (
    <div>
      <PageHeader
        title={title}
        action={
          <Badge appearance="tint" color="warning">
            in Planung
          </Badge>
        }
      />
      <Card
        style={{
          maxWidth: '640px',
          padding: tokens.spacingVerticalL,
          display: 'flex',
          flexDirection: 'row',
          gap: tokens.spacingHorizontalM,
          alignItems: 'flex-start',
        }}
      >
        <ClockRegular fontSize={28} style={{ color: tokens.colorBrandForeground1, flexShrink: 0 }} />
        <Body1>
          {description ??
            'Diese Funktion ist Teil der Roadmap und wird in einer kommenden Iteration umgesetzt.'}
        </Body1>
      </Card>
    </div>
  );
}
